import { createContext } from 'react';

const QuizQuestion = createContext({
  isOnLastQuestion : null,
});

export default QuizQuestion;
